import {
  PUSH_BREADCRUMB_ITEM,
  POP_BREADCRUMB_ITEM,
  RESET_BREADCRUMB,
} from 'src/redux/Actions/Type';

export const pushBreadcrumbItem = (payload) => ({
  type: PUSH_BREADCRUMB_ITEM,
  payload,
});

export const popBreadcrumbItem = (payload) => ({
  type: POP_BREADCRUMB_ITEM,
  payload,
});

export const resetBreadcrumb = (preserve = false) => ({
  type: RESET_BREADCRUMB,
  payload: preserve,
});
